import React from "react";
import { Box, InputLabel, MenuItem, Select as MUISelect } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledMenuItem = styled(MenuItem)({
  padding: '0 8px',
  lineHeight: '1.5',
});

const StyledSelect = styled(MUISelect)({
  '& .MuiSelect-select': {
    padding: '6px 0px', 
    textAlign: 'left',
    fontSize: '14px',
  },
});

const Select = ({ errorMessage, options, onChange, label, value, ...props }) => {

  // console.log(options)

  return (
    <Box className="base-select-container">
      <InputLabel htmlFor={props.name} className="label-header" sx=
      {{
        fontWeight: '800', 
        lineHeight: '33.6px',
        color: '#6b7280',
        fontFamily: 'Nunito',
        fontSize: '14px',
        fontStyle: 'normal',
        }}>
        {label}
      </InputLabel>
      <StyledSelect
        onChange={onChange}
        {...props}
        className={`base-select `}
        disabled={props.disabled ? true : false}
        value={value}
      >
        <StyledMenuItem value="">
          Select {label}
        </StyledMenuItem>
        {options.map((option) => (
          <StyledMenuItem key={option.key} value={option.value}>
            {option.label}
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </Box>
  );
};

export default Select;
